import { render, staticRenderFns } from "./AboutHistory.vue?vue&type=template&id=44464b53&"
import script from "./AboutHistory.vue?vue&type=script&lang=js&"
export * from "./AboutHistory.vue?vue&type=script&lang=js&"
import style0 from "./AboutHistory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports